import { render, staticRenderFns } from "./ClientRequestAssignModal.vue?vue&type=template&id=4cc00d98"
import script from "./ClientRequestAssignModal.vue?vue&type=script&lang=js"
export * from "./ClientRequestAssignModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports